module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/578f374d5658348b6ce936fe1497315e.gif";